import { render, staticRenderFns } from "./GruposSucursal.vue?vue&type=template&id=45c801d5"
import script from "./GruposSucursal.vue?vue&type=script&lang=js"
export * from "./GruposSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports